// src/utils/errorHandler.js
// Utilitários para tratamento de erros e redução de logs no console

// Suprimir erros específicos do console
const originalConsoleError = console.error;
const originalConsoleWarn = console.warn;

console.error = function(...args) {
  // Filtrar erros específicos que queremos ignorar
  const message = args.join(' ');

  // Ignorar TODOS os erros relacionados a WebSocket
  if (message.includes('WebSocket connection') ||
      message.includes('Invalid frame header') ||
      message.includes('WebSocketClient.js') ||
      message.includes('WebSocket is already in CLOSING or CLOSED state') ||
      message.includes('WebSocket connection to') ||
      message.includes('ws://') ||
      message.includes('sockjs-node') ||
      message.includes('hot update')) {
    return; // Silenciar completamente
  }

  // Ignorar erros do YouTube Player
  if (message.includes('YOUTUBEJS') ||
      message.includes('Failed to extract signature') ||
      message.includes('tbvws.js')) {
    return;
  }

  // Ignorar erros de proxy
  if (message.includes('Proxy error') ||
      message.includes('ECONNREFUSED') ||
      message.includes('ENOTFOUND')) {
    return;
  }

  // Para outros erros, usar o console original
  originalConsoleError.apply(console, args);
};

console.warn = function(...args) {
  const message = args.join(' ');

  // Ignorar warnings relacionados ao WebSocket e hot reloading
  if (message.includes('WebSocket') ||
      message.includes('hot update') ||
      message.includes('webpack') ||
      message.includes('development')) {
    return;
  }

  // Para outros warnings, usar o console original
  originalConsoleWarn.apply(console, args);
};

// Função para verificar se estamos em ambiente de desenvolvimento
export const isDevelopment = process.env.NODE_ENV === 'development';

// Função para log condicional
export const devLog = (...args) => {
  if (isDevelopment) {
    console.log(...args);
  }
};

export const devError = (...args) => {
  if (isDevelopment) {
    console.error(...args);
  }
};

export const devWarn = (...args) => {
  if (isDevelopment) {
    console.warn(...args);
  }
};